'use strict';
import moment from 'moment';
import 'moment/locale/ru';
import Price from './price';
import { fixed } from '../../utils/formater';
import { TREND_DOWN, TREND_UP } from '../../consts';

/**
 * История изменения цены
 * @param data {Immutable.List}
 * @constructor
 */
export function PriceHistory (data) {
  this.itemList = data.map(item => {
    const price = new Price(item.get('newPrice'));

    return new PriceHistoryItem(
      price,
      item.get('deltaPrice'),
      item.get('timestamp'));
  }).sort((a, b) => b.getDate() - a.getDate());

  this.startPrice = this.itemList.last().getPricePrev();
  this.trend = this.itemList.first().getTrend();
}

PriceHistory.prototype.getItemList = function () {
  return this.itemList;
};

/**
 * Возвращает часть истории
 * если reverse === false - то вернет часть до index
 * если reverse === true - то вернет часть после index
 * @param index
 * @param reverse
 * @returns {Immutable.List | null}
 */
PriceHistory.prototype.splitItems = function (index, reverse = false) {
  if (reverse === false) {
    return this.itemList.take(index);
  }

  const size = this.itemList.count();

  return size > index ? this.itemList.takeLast(size - index) : null;
};

/**
 * Начальная цена
 * @returns {Price|*}
 */
PriceHistory.prototype.getStartPrice = function () {
  return this.startPrice;
};

PriceHistory.prototype.getTrend = function () {
  return this.trend;
};

/**
 * Один этап в истории цены
 * @param price {Price}
 * @param delta {Number}
 * @param date {Number}
 * @constructor
 */
export function PriceHistoryItem (price, delta, date) {
  this.price = price;
  this.delta = new Price(delta);
  this.pricePrev = new Price(price.getValue() - this.delta.getValue());
  this.trend = this.delta.getValue() > 0 ? TREND_UP : TREND_DOWN;

  this.date = moment.unix(date);
  this.date.locale('ru');
}

PriceHistoryItem.prototype.getTrend = function () {
  return this.trend;
};

PriceHistoryItem.prototype.getDelta = function () {
  return this.delta;
};

PriceHistoryItem.prototype.getDate = function () {
  return this.date;
};

/**
 * Текущая цена
 * @returns {Price|*}
 */
PriceHistoryItem.prototype.getPrice = function () {
  return this.price;
};

/**
 * Старая цена
 * @returns {Price}
 */
PriceHistoryItem.prototype.getPricePrev = function () {
  return this.pricePrev;
};

/**
 * Разница между старой и новой ценой в процентах
 * @returns {number}
 */
PriceHistoryItem.prototype.getDeltaPercent = function () {
  const delta = this.getDelta().getValue();
  if (delta === 0) {
    return 0;
  }

  if (this.getPricePrev().getValue() === 0) {
    return delta > 0 ? 100 : -100;
  }

  return delta / this.getPricePrev().getValue() * 100;
};

/**
 * Форматированная разница цен в процентах
 * @returns {string}
 */
PriceHistoryItem.prototype.getDeltaPercentLabel = function () {
  const delta = fixed(Math.abs(this.getDeltaPercent()), 1);
  const trend = this.getDelta().getValue() > 0 ? '+' : '-';

  return trend + '' + delta.replace('.0', '') + '%';
};



// WEBPACK FOOTER //
// ./src/classes/finance/priceHistory.js